export default "<iframe id=\"my-sports\" src=\"{{'/admin/mysports/' + vm.language}}\"></iframe>\n";